import React from 'react';
import { useTheme } from '@context/ThemeContext';
import Icon from './Icon';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2.5 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200 group relative overflow-hidden"
      aria-label="Toggle theme"
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-amber-500/10 to-orange-500/10 dark:from-indigo-500/10 dark:to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className={`theme-icon relative transition-transform duration-500 ${theme === 'dark' ? 'rotate-180' : 'rotate-0'}`}>
        <Icon
          name={theme === 'light' ? 'Sun' : 'Moon'}
          size={20}
          className="text-amber-600 dark:text-indigo-400 group-hover:scale-110 transition-transform"
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
